import React, { useState, useRef, useEffect } from 'react'

const NavThemeToggle = ({ mode, activeTheme, onChange }) => {
    const [open, setOpen] = useState(false)
    const wrapRef = useRef(null)

    // Close on click outside
    useEffect(() => {
        const handler = (e) => {
            if (wrapRef.current && !wrapRef.current.contains(e.target)) {
                setOpen(false)
            }
        }
        document.addEventListener('mousedown', handler)
        return () => document.removeEventListener('mousedown', handler)
    }, [])

    const handleSelect = (selectedMode) => {
        onChange(selectedMode)
        setOpen(false)
    }

    const getIcon = () => {
        if (mode === 'light' || (mode === 'system' && activeTheme === 'light')) {
            return (
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <circle cx="12" cy="12" r="5" />
                    <line x1="12" y1="1" x2="12" y2="3" />
                    <line x1="12" y1="21" x2="12" y2="23" />
                    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
                    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
                    <line x1="1" y1="12" x2="3" y2="12" />
                    <line x1="21" y1="12" x2="23" y2="12" />
                    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
                    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
                </svg>
            )
        }
        return (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
            </svg>
        )
    }

    const getModeLabel = () => {
        if (mode === 'system') return 'System'
        return mode === 'dark' ? 'Dark' : 'Light'
    }

    return (
        <div className="v2-theme-dropdown-wrap" ref={wrapRef} style={{ position: 'relative', display: 'inline-block' }}>
            <button
                type="button"
                className={`v2-nav-theme-toggle ${open ? 'is-active' : ''}`}
                onClick={() => setOpen(!open)}
                aria-label="Select color theme"
                aria-expanded={open}
                title={`Theme: ${getModeLabel()}`}
            >
                {getIcon()}
                <span className="v2-nav-theme-toggle-label">{getModeLabel()}</span>
                <svg className="v2-theme-caret" width="8" height="8" viewBox="0 0 10 10" style={{ marginLeft: 2, opacity: 0.6, transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}>
                    <path d="M2 3.5L5 6.5L8 3.5" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>

            {open && (
                <div className="v2-theme-dropdown-menu" role="menu">
                    <button
                        type="button"
                        role="menuitem"
                        className={`v2-theme-dropdown-item ${mode === 'light' ? 'is-selected' : ''}`}
                        onClick={() => handleSelect('light')}
                    >
                        <svg className="v2-theme-item-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="5" /><line x1="12" y1="1" x2="12" y2="3" /><line x1="12" y1="21" x2="12" y2="23" /><line x1="4.22" y1="4.22" x2="5.64" y2="5.64" /><line x1="18.36" y1="18.36" x2="19.78" y2="19.78" /><line x1="1" y1="12" x2="3" y2="12" /><line x1="21" y1="12" x2="23" y2="12" /><line x1="4.22" y1="19.78" x2="5.64" y2="18.36" /><line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
                        </svg>
                        <span>Light</span>
                        {mode === 'light' && <span className="v2-theme-check">✓</span>}
                    </button>
                    <button
                        type="button"
                        role="menuitem"
                        className={`v2-theme-dropdown-item ${mode === 'dark' ? 'is-selected' : ''}`}
                        onClick={() => handleSelect('dark')}
                    >
                        <svg className="v2-theme-item-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
                        </svg>
                        <span>Dark</span>
                        {mode === 'dark' && <span className="v2-theme-check">✓</span>}
                    </button>
                    <button
                        type="button"
                        role="menuitem"
                        className={`v2-theme-dropdown-item ${mode === 'system' ? 'is-selected' : ''}`}
                        onClick={() => handleSelect('system')}
                    >
                        <svg className="v2-theme-item-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                            <line x1="8" y1="21" x2="16" y2="21"/>
                            <line x1="12" y1="17" x2="12" y2="21"/>
                        </svg>
                        <span>System</span>
                        {mode === 'system' && <span className="v2-theme-check">✓</span>}
                    </button>
                </div>
            )}
        </div>
    )
}

export default NavThemeToggle
